export const AUTH_JWT_KEY = 'app.auth_jwt';
